// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumbs_wrapper__O1xwu","item":"Breadcrumbs_item__Smr3g","itemLast":"Breadcrumbs_itemLast__+pADy","itemParent":"Breadcrumbs_itemParent__eXKkT"};